function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M246.179 162.076C244.195 157.107 238.56 154.687 233.591 156.67C228.623 158.654 226.202 164.289 228.186 169.258C230.707 175.576 229.881 182.789 225.974 188.555C222.065 194.324 215.806 197.633 208.803 197.633H41.2351C33.596 197.633 26.8123 193.647 23.0879 186.969C19.3577 180.28 19.5331 172.398 23.5568 165.883L107.341 30.2311C111.156 24.0543 117.764 20.3668 125.019 20.3668C132.274 20.3668 138.882 24.0543 142.697 30.2311L204.662 130.558C207.474 135.109 213.443 136.521 217.994 133.708C222.545 130.898 223.957 124.929 221.145 120.377L159.179 20.0505C151.809 8.11732 139.039 0.993082 125.019 0.993082C110.998 0.993082 98.2281 8.1178 90.8578 20.0505L7.07388 155.703C-0.693614 168.28 -1.03171 183.496 6.16857 196.406C13.363 209.305 26.4718 217.006 41.2351 217.006H208.803C222.335 217.006 234.44 210.596 242.012 199.422C249.527 188.33 251.085 174.369 246.179 162.076Z",
  fill: "#FF5A5F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M125.023 178.744C130.373 178.744 134.71 174.407 134.71 169.057C134.71 163.707 130.373 159.371 125.023 159.371H125.019C119.669 159.371 115.334 163.707 115.334 169.057C115.334 174.407 119.673 178.744 125.023 178.744Z",
  fill: "#FF5A5F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M134.706 135.154V63.9564C134.706 58.6065 130.369 54.2698 125.019 54.2698C119.669 54.2698 115.332 58.6065 115.332 63.9564V135.154C115.332 140.504 119.669 144.84 125.019 144.84C130.369 144.84 134.706 140.504 134.706 135.154Z",
  fill: "#FF5A5F"
});

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 218,
    viewBox: "0 0 249 218",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.8a02e5c1.svg";
export { ForwardRef as ReactComponent };